import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("微信linux bot")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("公众号后台")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("微博")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("百度爬虫")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("B站")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_menu, {
      mode: "horizontal",
      router: "",
      "default-active": "/bot/wechat-bot"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/bot/wechat-linux-bot" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/bot/wxmp-bot" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/bot/weibo-bot" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/bot/baidu-image-spider" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/bot/bilibili-bot" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}